/**
 * AUTO-GENERATED by agent-contracts-runtime. DO NOT EDIT.
 *
 * Regenerate via: npx agent-runtime generate
 */

export interface DelegateStep {
  readonly type: "delegate";
  readonly task: string;
  readonly from_agent: string;
  readonly description: string;
  readonly optional: boolean;
  readonly max_retries: number;
  readonly depends_on?: readonly string[];
}

export interface GateStep {
  readonly type: "gate";
  readonly gate_kind: string;
  readonly description: string;
  readonly depends_on?: readonly string[];
}

export type WorkflowStep = DelegateStep | GateStep;

export interface WorkflowContract {
  readonly id: string;
  readonly description: string;
  readonly trigger: string;
  readonly entry_conditions: readonly string[];
  readonly steps: readonly WorkflowStep[];
}

export const implementLlmFeature: WorkflowContract = {
  id: "implement-llm-feature",
  description: "Implement LLM-powered commands in a CLI tool",
  trigger: "cli-command",
  entry_conditions: [
  "Target project is a TypeScript / Node.js project",
  "cli-contract.yaml exists or is being created"
],
  steps: [
    {
      type: "delegate",
      task: "implement-llm-feature",
      from_agent: "llm-feature-implementer",
      description: "",
      optional: false,
      max_retries: 0,
    },
  ],
};

export const auditImplementation: WorkflowContract = {
  id: "audit-implementation",
  description: "Audit an LLM command integration for pattern conformance",
  trigger: "cli-command",
  entry_conditions: [
  "Target project has LLM command integration to audit"
],
  steps: [
    {
      type: "delegate",
      task: "audit-dsl",
      from_agent: "implementation-auditor",
      description: "",
      optional: false,
      max_retries: 0,
      depends_on: [],
    },
    {
      type: "delegate",
      task: "audit-runtime",
      from_agent: "implementation-auditor",
      description: "",
      optional: false,
      max_retries: 0,
      depends_on: [],
    },
    {
      type: "delegate",
      task: "audit-cli-contract",
      from_agent: "implementation-auditor",
      description: "",
      optional: false,
      max_retries: 0,
      depends_on: [],
    },
    {
      type: "delegate",
      task: "audit-architecture",
      from_agent: "implementation-auditor",
      description: "",
      optional: false,
      max_retries: 0,
      depends_on: [],
    },
    {
      type: "delegate",
      task: "audit-merge",
      from_agent: "implementation-auditor",
      description: "",
      optional: false,
      max_retries: 0,
      depends_on: [
  "audit-dsl",
  "audit-runtime",
  "audit-cli-contract",
  "audit-architecture"
],
    },
  ],
};

export const workflowRegistry: Record<string, WorkflowContract> = {
  "implement-llm-feature": implementLlmFeature,
  "audit-implementation": auditImplementation,
};
